<template>
  <div id="main">
    <map-component />
    <zoombar-component />
    <div id="statusbar" class="has-background-black-ter">
      <mouse-position-component v-if="$conf.mouseposition.enabled" />
      <scale-line-component v-if="$conf.scaleline.enabled" />
      <span class="copyrights" v-if="$conf.copyrights.length" v-html="copyrights"></span>
    </div>
    <sidebar-component />
    <timebar-component
      v-if="$conf.timebar.enabled"
      :minDate="$conf.timebar.minDate"
      :maxDate="$conf.timebar.maxDate"
      :from="$conf.timebar.rangeMinDate"
      :to="$conf.timebar.rangeMaxDate"
      :value="$conf.timebar.rangeMaxDate"
      :milestones="$conf.timebar.deadLines" />
    <layer-switcher-component
      v-if="showLayerSwitcher"
      :activeLayer="checkedLayer"
      :onChange="layerChanged"
      :layers="$conf.map.layers.baseLayers"
      position="is-bottom-left"
      class="map-lsw">
    </layer-switcher-component>
  </div>
</template>

<script>

import MapComponent from 'comp/map/Map'
import ZoombarComponent from 'comp/map/Zoombar'
import SidebarComponent from 'comp/sidebar/Sidebar'
import TimebarComponent from 'comp/Timebar'
import ScaleLineComponent from 'comp/map/ScaleLine'
import MousePositionComponent from 'comp/map/MousePosition'
import LayerSwitcherComponent from 'comp/map/LayerSwitcher'

export default {
  components: {
    MapComponent,
    ZoombarComponent,
    SidebarComponent,
    TimebarComponent,
    ScaleLineComponent,
    MousePositionComponent,
    LayerSwitcherComponent
  },
  data () {
    return {
      username : '',
      password : '',
      rememberme: false,
      layers: Object.keys(this.$conf.map.layers.baseLayers) || [],
      checkedLayer: this.$conf.map.baseLayer || ''
    }
  },
  computed: {
    showLayerSwitcher () {
      return this.$conf.layerswitcher.enabled && this.layers.length > 1
    },
    copyrights () {
      return this.$conf.copyrights.map(item => {
        return item.url ?
          `<a href="${ item.url }" target="_blank">${ item.text }</a>` :
          item.text
      }).join(' | ')
    }
  },
  mounted () {
    this.layerChanged()
  },
  methods: {
    layerChanged (layer) {
      this.checkedLayer = layer
      this.$store.dispatch('setBaseLayer', layer)
    }
  }
}

</script>

<style lang="stylus">

#main
  height: 100%
  #statusbar
    position: absolute
    right: 0
    bottom: 0
    padding: 2px 2px 2px 10px
    border-radius: 4px 0 0 0
    font-size: .8rem
    color: white
    a
      color: white
  .map-lsw
    position: absolute
    top: 10px
    right: 44px
    z-index: 1004
</style>
